import { productCategories } from '../../data/siteData'
import { productsHero } from '../../data/productsPageData'
import SplitPageHero from '../common/SplitPageHero'
import {
  IconAllProducts,
  IconFerrous,
  IconIndustrial,
  IconNonFerrous,
  IconRawMaterials,
  IconScrap,
} from '../icons/ProductsCategoryIcons'

const categoryIcons = {
  all: IconAllProducts,
  'non-ferrous': IconNonFerrous,
  ferrous: IconFerrous,
  industrial: IconIndustrial,
  raw: IconRawMaterials,
  scrap: IconScrap,
}

function ProductsPageHero({ activeCategory, onCategoryChange }) {
  const { eyebrow, description, image, imageAlt, primaryCta, secondaryCta } = productsHero

  return (
    <SplitPageHero
      id="products-page-heading"
      eyebrow={eyebrow}
      title={
        <>
          Premium <span className="split-page-hero__title-accent">Metals</span>
          <br />
          <span className="split-page-hero__title-accent">Global</span> Standards
        </>
      }
      description={description}
      image={image}
      imageAlt={imageAlt}
      imagePosition="center center"
      primaryCta={primaryCta}
      secondaryCta={secondaryCta}
    >
      <div className="products-page-hero__nav-wrap">
        <div className="container corp-container">
          <nav className="products-category-nav" aria-label="Product categories">
            {productCategories.map((category) => {
              const Icon = categoryIcons[category.id]
              const isActive = activeCategory === category.id
              return (
                <button
                  type="button"
                  key={category.id}
                  className={`products-category-nav__item${isActive ? ' is-active' : ''}`}
                  onClick={() => onCategoryChange(category.id)}
                  aria-current={isActive ? 'true' : undefined}
                >
                  <span className="products-category-nav__icon">
                    <Icon active={isActive} />
                  </span>
                  <span className="products-category-nav__label">{category.label}</span>
                  {isActive ? (
                    <span className="products-category-nav__indicator" aria-hidden="true" />
                  ) : null}
                </button>
              )
            })}
          </nav>
        </div>
      </div>
    </SplitPageHero>
  )
}

export default ProductsPageHero
